import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=3ab18e4c&"
import script from "./iconButton.js?vue&type=script&lang=js&"
export * from "./iconButton.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports